var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "ap-workspace-head" }, [
        _c("div", { staticClass: "ap-workspace-label" }, [
          _c("div", { staticClass: "ap-workspace-label-name" }, [
            _vm._v("\n                    Проекты\n                ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ap-workspace-label-btn",
              on: {
                click: function($event) {
                  return _vm.confirmTransition()
                }
              }
            },
            [_c("SVGPlus")],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ap-workspace-label-btn ap-add-left-margin" },
          [
            _c("label", { staticClass: "ap-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mask,
                    expression: "mask"
                  }
                ],
                staticClass: "ap-search-input",
                attrs: { type: "text", placeholder: "Найти проект" },
                domProps: { value: _vm.mask },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.mask = $event.target.value
                  }
                }
              })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "vue-custom-scrollbar",
        { on: { "ps-y-reach-end": _vm.scrollReachEnd } },
        [
          _c(
            "div",
            {
              staticClass:
                "ap-workspace-table-container workspace-admin-scroll-part"
            },
            [
              _c("table", { staticClass: "result-table" }, [
                _c("thead", [
                  _c("tr", { staticClass: "head-tr" }, [
                    _c("th", [_vm._v("№")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Название")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Дата создания")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Менеджер")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Заказчик")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Изображение")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Доступен в Lite")]),
                    _vm._v(" "),
                    _c("th", { staticClass: "field-edit" }, [_vm._v("Опции")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.projects, function(value, index) {
                    return _c("tr", { staticClass: "body-tr row" }, [
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(index + 1))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(value.data_json.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(_vm.dateIntoRu(value.create_date)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(value.users, function(user) {
                          return _c("span", { staticClass: "table-data" }, [
                            _vm._v(_vm._s(user.fullname))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: value.customers.length === 0,
                                  expression: "value.customers.length === 0"
                                }
                              ],
                              staticClass: "table-data"
                            },
                            [_vm._v("Нет заказчика")]
                          ),
                          _vm._v(" "),
                          _vm._l(value.customers, function(customer) {
                            return _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: value.customers.length > 0,
                                    expression: "value.customers.length > 0"
                                  }
                                ],
                                staticClass: "table-data"
                              },
                              [_vm._v(_vm._s(customer.name))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("img", {
                          staticClass: "ap-table-img",
                          attrs: {
                            src: _vm.getFirstImg(value.data_json.photoList)
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(_vm.convertToWord(value.open_read)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "edit-button-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "table-svg-button",
                              on: {
                                click: function($event) {
                                  return _vm.editRow(value)
                                }
                              }
                            },
                            [_c("SVGAdminEditRow")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "table-svg-button",
                              on: {
                                click: function($event) {
                                  return _vm.confirm(value)
                                }
                              }
                            },
                            [_c("SVGAdminDeleteRow")],
                            1
                          )
                        ])
                      ])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm.waitingResponseToProjectsRequest
                ? _c(
                    "div",
                    { staticClass: "ap-loader-grid" },
                    [
                      _c("SpinnerTwo"),
                      _vm._v(" "),
                      _c("div", { staticClass: "ap-loader-text" }, [
                        _vm._v(
                          "\n                    Идет загрузка проектов ...\n                "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }